<template>
    <div class="wrapper" @click="show=false">
        <b-container>
            <mini-nav class="mt-4" @searchYear="searchYear">
                <template>
                    <div>
                        <div class="year-btn" @click.stop="show=!show">
                            <div><span style="padding-right: 2rem">{{$t('lang.YEAR')}}：</span>{{ yearActive }}</div>
                            <b-icon class="arrow" icon="chevron-down"></b-icon>
                        </div>
                        <div v-show="show" class="drop-down" @mouseleave="show=false">
                            <div
                                class="drop-item"
                                v-for="(item, index) in year.sub"
                                :key="index"
                                @click="searchYear(item.text)"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </template>
            </mini-nav>
            <intro-scroll :introList="introList"></intro-scroll>
            <!-- <layoutimg :dataList="scienceList" :cols="12" :md="3"></layoutimg> -->
            <div v-for="(item, index) in scienceList" :key="index">
                 <layout :cols="12" :md="3" type="unnormal" :dataList="item.list">
                    <template v-slot:title>
                        <div class="title">{{item.year}}</div>
                    </template>
                </layout>
            </div>
           
        </b-container>
    </div>
</template>
<script>
import layout from '@/components/layout.vue';
import miniNav from '@/views/about/miniNav/miniNav.vue';
import introScroll from '@/components/introScroll.vue';

export default {
    components:{ miniNav, introScroll, layout },
    data(){
        return{
            show: false,
            scienceList:[],
            introList:[],
            year: {
				text: '年份',
				link: '',
				sub: [
                   { text: 'ALL'}
				],
            },
            yearActive: 'ALL',
        }
    },
    created(){
        this.getList(4)
        this.getCharacterYears()
    },
    methods:{
         getCharacterList(type, year){
            this.$api.characterList({ 
                type: type,
                awardYear: year == 'ALL' ? '' : year,
                sortType: 'year'
            })
            .then(res=>{
                // console.log(res.data)
                this.introList = res.data
            })
        },
        getList(type, year){
            this.$api.characterList({ 
                type: type,
                awardYear: year,
                sortType: 'year'
            })
            .then(res=>{
                console.log('科学委员会>>>>>>>>>>>>>',res.data)
                this.scienceList = res.data
                // let keyArr = Object.keys(res.data)
                // let valueArrr = Object.values(res.data)
                // this.scienceList = valueArrr.map((item, index)=>{
                //     return{
                //         text: keyArr[index],
                //         list: item
                //     }
                // })
            })
        },
        searchYear(text){
            this.yearActive = text
            this.getList(4, text=='ALL'? '': text)
            this.getCharacterList(5, this.yearActive );
        },
          //获取年份
        getCharacterYears(){
            this.$api.characterYears()
            .then(res => {
                let arr = res.data.map(item => {
                    return {
                        text: item
                    }
                })
                this.year.sub.push(...arr)
                this.getCharacterList(5, this.yearActive); //科学委员会
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.title{
    text-align: center;
    padding: 4rem 0;
    font-size: 1.6rem;
    color: $science-theme-color;
}
.year-btn {
    display: flex;
    padding: 0 2rem;
    align-items: center;
    cursor: pointer;
}
.drop-down {
    position: relative;
    text-align: center;
    background-color: #fff;
    z-index: 999;
    cursor: pointer;
    width: 70%;
    left: 30%;
    .drop-item:hover {
        color: #c8a063;
    }
}
</style>